module.exports = __webpack_public_path__ + "media/smart_sales/icon-2-f809b844.svg";